import { jsx as _jsx } from "react/jsx-runtime";
import { DockButton } from "./DockButton";
export function DockAction({ icon, onClick, title, active, disabled }) {
    return (_jsx(DockButton, { icon: icon, title: title, active: active, disabled: disabled, onClick: onClick }));
}
